/**
 * Navigation API service
 */

import { fetchStrapi, getStrapiMediaUrl } from './strapi';

export interface MenuItem {
  label: string;
  path: string;
  isButton: boolean;
  buttonColor: string | null;
}

export interface Navigation {
  logoUrl: string | null;
  logoText: string;
  logoTextColor: string;
  showLogoText: boolean;
  menuItems: MenuItem[];
  backToHomeText: string;
  sectionsLabel: string;
  onThisPageLabel: string;
}

/**
 * Fetch navigation data from Strapi
 */
export async function fetchNavigation(): Promise<Navigation | null> {
  try {
    const response = await fetchStrapi<any>(
      '/navigation?populate=*'
    );

    if (!response.data) {
      return null;
    }

    const data = response.data;

    // Get logo URL from media field (handle both Strapi 4 and 5 formats)
    let logoUrl: string | null = null;
    if (data.logo?.data?.attributes?.url) {
      logoUrl = getStrapiMediaUrl(data.logo.data.attributes.url);
    } else if (data.logo?.url) {
      logoUrl = getStrapiMediaUrl(data.logo.url);
    }

    return {
      logoUrl,
      logoText: data.logoText || 'Gerald Fasching',
      logoTextColor: data.logoTextFarbe || '#1A2B3C',
      showLogoText: data.logoTextAnzeigen ?? true,
      menuItems: (data.menuePunkte || []).map((m: any) => ({
        label: m.label,
        path: m.path,
        isButton: m.istButton,
        buttonColor: m.buttonFarbe,
      })),
      backToHomeText: data.zurueckZurStartseiteText || '',
      sectionsLabel: data.sektionenLabel || '',
      onThisPageLabel: data.aufDieserSeiteLabel || '',
    };
  } catch (error) {
    console.error('Error fetching navigation from Strapi:', error);
    return null;
  }
}

